<template>
  <div>
    <Analytic-Map />
    <br>
    <Analytic-Static />
    <Analytic-Static-AI />
    <br>
    <Analytic-Gauge />
    <br>
    <AnalyticTable />
    <!-- <Analytic-Graph /> -->
    <br>
  </div>
</template>

<script>
import AnalyticStatic from '@/views/analytic120/detail/AnalyticStatic.vue'
import AnalyticStaticAI from '@/views/analytic120/detail/AnalyticStaticAI.vue'
import AnalyticMap from '@/views/analytic120/detail/AnalyticMapDetail.vue'
import AnalyticGauge from '@/views/analytic120/detail/AnalyticGauge.vue'
import AnalyticTable from '@/views/analytic120/detail/AnalyticTable.vue'
// import AnalyticGraph from '@/views/analytic120/detail/AnalyticGraph.vue'
// import axios from '@axios'
export default {
  components: {
    AnalyticMap,
    AnalyticStatic,
    AnalyticStaticAI,
    AnalyticGauge,
    AnalyticTable,
    // AnalyticGraph,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style>
</style>
